import { User } from './models';

export interface UserState {
  user: Partial<User> | null;
  token: string;
  loggedIn: boolean;
  registrationSuccess: boolean;
  error: string | null;
  otp: {
    expiresOn: Date | null;
  };
  registrationToken: string;
  resetToken: string;
  resetPasswordSuccess: boolean;
  isImpersonating: boolean;
  impersonationPending: boolean;
  impersonationRequested: boolean;
  impersonationTargetUserId: string | null;
  impersonationError: string | null;
  tutorsList: any | null;
  selectedTutorProfile: { tutor: any; courses: any[]; liveClasses: any[] } | null;
  tutorsLoading: boolean;
  tutorProfileLoading: boolean;
  tutorProfileError: string | null;
}

export const initialState: UserState = {
  user: null,
  token: '',
  loggedIn: false,
  registrationSuccess: false,
  error: null,
  otp: {
    expiresOn: null,
  },
  registrationToken: '',
  resetToken: '',
  resetPasswordSuccess: false,
  isImpersonating: false,
  impersonationPending: false,
  impersonationRequested: false,
  impersonationTargetUserId: null,
  impersonationError: null,
  tutorsList: null,
  selectedTutorProfile: null,
  tutorsLoading: false,
  tutorProfileLoading: false,
  tutorProfileError: null,
};
